// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"512":"1e28de8b","555":"1a2c846d","917":"c1666b20"}[chunkId] + ".chunk.css";
};